<mat-icon *ngIf="options[status]" [style.color]="options[status].color" [matTooltip]="options[status].name">
  {{options[status].icon}}
</mat-icon>